<template>
  <b-row>
    <b-col md="12" class="mb-4">
      <div style="float:right">
        <b-button variant="info" style="color:#ffffff" v-bind:href="'#/product/userauthpermission/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
      </div>
    </b-col>
    <b-col md="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="6">
            <b-form-group
              label="상품명 검색"
              label-for="basicSelectSm"
              :label-cols="2"
              :horizontal="true">
              <b-form-input id="basicText" type="text" v-model="queryParams.p_name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="상품코드 검색"
              label-for="basicSelectSm"
              :label-cols="2"
              :horizontal="true">
              <b-form-input id="basicText" type="text" v-model="queryParams.p_code"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="mt-0">
        <b-row class="pt-sm-1">
          <b-col sm="12">
            <b-form-group
              label="검색 옵션"
              label-for="basicSelectSm"
              :label-cols="1"
              :horizontal="true">

              <b-form-group
                label="상품구분"
                label-for="basicText"
                :label-cols="1"
                :horizontal="true">
                <b-row class="pt-sm-12">
                  <b-col sm="12">
                    <label class="col-form-label">
                      <b-form-checkbox-group id="basicInlineCustomCheckboxes">
                        <div class="custom-control custom-checkbox custom-control-inline" v-for="(item, idx) in productTypeOptions">
                          <input type="checkbox" class="custom-control-input" :id="'customInChk'+(idx+1)" v-model="productTypeArr[item.item_code]">
                          <label class="custom-control-label" :for="'customInChk'+(idx+1)">{{item.item_name}}</label>
                        </div>
                      </b-form-checkbox-group>
                    </label>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group
                label="상품기간"
                label-for="basicText"
                :label-cols="1"
                :horizontal="true">
                <b-row class="pt-sm-12">
                  <b-col sm="12">
                    <label class="col-form-label">
                      <b-form-checkbox-group id="basicInlineCustomCheckboxes">
                        <div class="custom-control custom-checkbox custom-control-inline" v-for="(item, idx) in productPeriodTypeOptions">
                          <input type="checkbox" class="custom-control-input" :id="'customInPeriodChk'+(idx+1)" v-model="productPeriodTypeArr[item.item_code]">
                          <label class="custom-control-label" :for="'customInPeriodChk'+(idx+1)">{{item.item_name == 0 ? '기간지정' : item.item_name }} <span v-show="(idx+1) != productPeriodTypeOptions.length">개월</span></label>
                        </div>
                      </b-form-checkbox-group>
                    </label>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group
                label="노출여부"
                label-for="basicText"
                :label-cols="1"
                :horizontal="true">
                <b-row class="pt-sm-12">
                  <b-col sm="12">
                    <label class="col-form-label">
                      <b-form-checkbox-group id="basicInlineCustomCheckboxes">
                        <div class="custom-control custom-checkbox custom-control-inline" v-for="(item, idx) in productViewTypeOptions">
                          <input type="checkbox" class="custom-control-input" :id="'customInViewChk'+(idx+1)" v-model="productViewTypeArr[item.item_code]">
                          <label class="custom-control-label" :for="'customInViewChk'+(idx+1)">{{item.item_name}}</label>
                        </div>
                      </b-form-checkbox-group>
                    </label>
                  </b-col>
                </b-row>
              </b-form-group>
              <!-- <b-form-group
                label="상품구분"
                label-for="basicText"
                :label-cols="1"
                :horizontal="true">
                <b-row class="pt-sm-12">
                  <b-col sm="12">
                    <label class="col-form-label">
                      <b-form-checkbox-group id="basicInlineCustomCheckboxes">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input type="checkbox" class="custom-control-input" id="customInChk_all" v-model="productTypeArr.all" v-on:click="productTypeArr = {all: true}">
                          <label class="custom-control-label" for="customInChk_all">전체</label>
                        </div>
                        <div class="custom-control custom-checkbox custom-control-inline" v-for="(pitem, idx) in productTypeOptions">
                          <input type="checkbox" class="custom-control-input" :id="'customInChk'+(idx+1)" v-model="productTypeArr[pitem.item_code]" :disabled="productTypeArr.all">
                          <label class="custom-control-label" :for="'customInChk'+(idx+1)">{{pitem.item_name}}</label>
                        </div>
                      </b-form-checkbox-group>
                    </label>
                  </b-col>
                </b-row>
              </b-form-group> -->

            </b-form-group>
          </b-col>
        </b-row>
        <hr class="mt-0">
        <div style="float:right">
          <b-button type="submit" variant="success" v-on:click="findDrProductAuthList()"><i class="fa fa-dot-circle-o"></i> 검색</b-button>
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <span class="card-title wise-card-title">검색 기준 </span>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="3">
                <div class="callout callout-info"><span class="text-muted" style="font-size:15px">상품명</span><br> <strong class="h4">{{searchData.p_name == undefined || searchData.p_name == '' ? '미입력' : searchData.p_name}}</strong></div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-success"><span class="text-muted"  style="font-size:15px">상품코드</span><br> <strong class="h4">{{searchData.p_code == undefined || searchData.p_code == '' ? '미입력' : searchData.p_code}}</strong></div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-danger"><span class="text-muted"  style="font-size:15px">상품구분</span><br> <strong class="h4" v-html="searchData.productTypeNames == undefined || searchData.productTypeNames == '' ? '미입력' : searchData.productTypeNames"></strong></div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-danger"><span class="text-muted"  style="font-size:15px">상품기간</span><br> <strong class="h4" v-html="searchData.productPeriodTypeNames == undefined || searchData.productPeriodTypeNames == '' ? '미입력' : searchData.productPeriodTypeNames"></strong></div>
              </b-col>
            </b-row>
            <hr class="mt-0">
          </b-col>
        </b-row>
        <br/>
        <div class="table-responsive-sm">
          <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr>
                      <th class="text-center">대상 기간</th>
                      <th class="text-center">전체 자료 수</th>
                  </tr>
              </thead>
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="text-center">
                          <div>
                              <strong style="font-size:15px">
                                <span v-if="searchData.dayAllCheck">현재의 모든 상품 전체</span>
                                <span v-if="!searchData.dayAllCheck">{{searchData.startday}} ~ {{searchData.endday}}</span>
                              </strong>
                          </div>
                      </td>
                      <td class="text-center">
                          <div>
                              <strong style="font-size:15px">{{items.length}} 건</strong>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>

      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <b-button size="sm" variant="danger" v-on:click="drUserAuthDelete()" :disabled="productDeleteRows.length == 0" :class="productDeleteRows.length != 0 ? 'mx-1 delete_button_on' : 'mx-1 delete_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
                <b-button size="sm" variant="info" v-on:click="drUserAuthDeleteClear()" :disabled="productDeleteRows.length == 0" :class="productDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 초기화</h5></b-button>
                <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="productDeleteRows.length == 0">* 삭제할 데이터를 선택해 주세요.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="productDeleteRows.length > 0">선택된 데이터 : {{productDeleteRows.length}}</span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :selectable="productListSelect"
                  :select-mode="'multi'"
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item, $event.target)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="p_name" slot-scope="data">
                    <div style="width:300px"><a href="javascript:void(0)" v-on:click="productAuthInfoGo(data.item)">{{data.item.p_name}}</a></div>
                  </template>
                  <template slot="period_date" slot-scope="data">
                    <div>{{data.item.period_start_date}} ~ {{data.item.period_end_date}}</div>
                  </template>
                  <template slot="period_name" slot-scope="data">
                    <div>{{data.item.period_code == 'PRDT_PERIOD_1' ? '기간지정' : data.item.period_name}}<br/><span v-if="data.item.period_code == 'PRDT_PERIOD_1'">(<span style="color:#c20000">{{data.item.period_start_date+' ~ '+data.item.period_end_date}}</span>)</span></div>
                  </template>
                  <template slot="price_total" slot-scope="data">
                    <div>￦ {{Number(data.item.price).toLocaleString()}}<br/>(<span style="color:#ea0000">{{'구매 : '+Number(data.item.in_purchase_cnt).toLocaleString()}}</span>)</div>
                  </template>
                  <template slot="dc_content" slot-scope="data">
                    <div>￦ {{data.item.dc_result_price != '' ? Number(data.item.dc_result_price).toLocaleString() : '적용안됨'}} ({{data.item.discount}} %)</div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/product/userauthpermission/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import datetimepicker from "daterangepicker/daterangepicker.js";
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'

const moment = require("moment");

export default {
  data() {
    return {
      productListSelect: false,
      dr_topdeth_code: '',
      dr_rtype: '',
      resultCateDatas: [], // code.js 각 코드들의 결과값
      productSearchType: [
        {text:'전체', value:'all'},
        {text:'상품명', value:'pname'},
        {text:'상품코드', value:'pcode'},
      ], // 상단 구분 셀렉트 박스 코드값
      selectCateItems: [], // 상단 구분 셀렉트 박스 코드값
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      productDeleteRows: [],
      searchData: {},
      queryParams: {
        dr_deth_code: '',
        searchType: 'all',
        type_code: 'all',
        day_code: 'dayall',
        categoryitems: [],
        productTypeSearchArr: [],
        productPeriodTypeSearchArr: [],
        productViewTypeSearchArr: [],
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      productTypeArr: {},
      productPeriodTypeArr: {},
      productViewTypeArr: {},
      productTypeOptions: [],
      productPeriodTypeOptions: [],
      productViewTypeOptions: [
        {item_code: 'Y', item_name: '노출'},
        {item_code: 'N', item_name: '비노출'}
      ],
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'p_code': {
          'label': '상품코드',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'p_name': {
          'label': '상품명',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'p_typename': {
          'label': '구분',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'period_name': {
          'label': '상품기간',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'price_total': {
          'label': '소비자가',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'dc_content': {
          'label': '할인가(할인기준)',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'view_yn': {
          'label': '노출여부',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_id': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
      categoryButtons: [],
      dateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'-1|days',state: false },
        { item_name: '1주일', item_code:'-7|days',state: false },
        { item_name: '1개월', item_code:'-1|months',state: false },
        { item_name: '6개월', item_code:'-6|months',state: false },
        { item_name: '1년', item_code:'-1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'productListSelect'() {
      this.productDeleteRows = [];
    }
  },
  mounted: function() {
     var self = this;
     // 상단 셀렉트 박스 코드 조회
     codeAPI.selectItemCodeList(self,"PRDT_TYPE_2",3,"productTypeOptions"); // 상품구분
     codeAPI.selectItemCodeBackList(self,"PRDT_PERIOD",2,"productPeriodTypeOptions"); // 상품기간
     self.productInit();
  },
  methods: {
    productInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      var drCodeArr = {};
      self.searchData = {};
      self.searchData.categoryNames = '';
      self.queryParams = {
        dr_deth_code: '',
        searchType: 'all',
        type_code: 'all',
        day_code: 'dayall',
        categoryitems:[],
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      };
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(idx == 0){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      self.findDrProductAuthList();

      // self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=RPT_CATE')
      // .then((result) => {
      //   var categoryDatas = result.data;
      //   categoryDatas.forEach(function (el, idx, arr){
      //     el.state = false;
      //   });
      //   self.categoryButtons = categoryDatas;
      //
      // })

      $(function() {
        $('input[name="daterange"]').daterangepicker({
          opens: 'left',
          "locale": self.calendarLocale,
          "endDate": moment().format('YYYY-MM-DD'),
          "startDate": moment().add(0, 'days').format('YYYY-MM-DD')
        }, function(start, end, label) {
          self.queryParams.start_date = start.format('YYYY-MM-DD');
          self.queryParams.end_date = end.format('YYYY-MM-DD');
        });
      });
    },
    // 메소드명 : findDrProductAuthList()
    // ### 계졍권한 리스트 조회 ###
    // 리포트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.07.01
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  황경현   최초작성
    // *************************
    findDrProductAuthList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var productTypeNames = '';
      var productPeriodTypeNames = '';
      var productViewTypeNames = '';
      self.queryParams.productTypeSearchArr = [];
      self.queryParams.productPeriodTypeSearchArr = [];
      self.queryParams.productViewTypeSearchArr = [];

      for(var type in self.productTypeArr){
  			if(self.productTypeArr.hasOwnProperty(type)){
  				if(self.productTypeArr[type] == true){
            if(type != "all"){
              self.queryParams.productTypeSearchArr.push(type);
              var codename = self.productTypeOptions.filter(function(item){
                return item.item_code == type ? item.item_name : '';
              })[0].item_name;
              productTypeNames += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+codename+"</span>&nbsp;&nbsp;";
            }
  				}
  			}
  		}
      for(var type in self.productPeriodTypeArr){
  			if(self.productPeriodTypeArr.hasOwnProperty(type)){
  				if(self.productPeriodTypeArr[type] == true){
            if(type != "all"){
              self.queryParams.productPeriodTypeSearchArr.push(type);
              var codename = self.productPeriodTypeOptions.filter(function(item){
                return item.item_code == type ? item.item_name : '';
              })[0].item_name;
              productPeriodTypeNames += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+codename+(type != 'PRDT_PERIOD_1' ? '개월' : '')+"</span>&nbsp;&nbsp;";
            }
  				}
  			}
  		}
      for(var type in self.productViewTypeArr){
  			if(self.productViewTypeArr.hasOwnProperty(type)){
  				if(self.productViewTypeArr[type] == true){
            if(type != "all"){
              self.queryParams.productViewTypeSearchArr.push(type);
              var codename = self.productViewTypeOptions.filter(function(item){
                return item.item_code == type ? item.item_name : '';
              })[0].item_name;
              productViewTypeNames += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+codename+"</span>&nbsp;&nbsp;";
            }
  				}
  			}
  		}

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/drProductAuthList?access_token=' + token, data, null)
      .then((result) => {
        self.items = result.data;
        self.items.forEach(function (el, idx, arr){
          el.rnum = self.items.length - (idx);
          el.selectchecked = false;
        });
        self.searchData.p_name = self.queryParams.p_name;
        self.searchData.p_code = self.queryParams.p_code;
        self.searchData.productTypeNames = productTypeNames;
        self.searchData.productPeriodTypeNames = productPeriodTypeNames;
      })
    },
    drListRows(rows, target) {
      var self = this;
      if(rows.in_purchase_cnt > 0){
        rows.selectchecked = false;
        target.checked = false;
        swal.fire({
          type: 'warning',
          title: '권한상품 삭제!',
          html: "<b>구매된 권한상품은 삭제할수 없습니다.</br><span style='color:#ea0000'>구매건 수 : "+rows.in_purchase_cnt+"건</span></b>",
          showConfirmButton: true
        })
        return false;
      }else{
        self.productDeleteRows = [];
        self.items.forEach(function (el, idx, arr){
          if(el.selectchecked){
            self.productDeleteRows.push(el.p_code);
          }
        });
      }
    },
    drUserAuthDelete(){
      var self = this;
      swal.fire({
        title: '계정상품 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 계정상품과 할인율,할인가 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.productDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.productDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.productDeleteRows));
          var data = new FormData();
          data.append('dcDelArr', param);

          self.$http.post('/api/delete/drUserAuth?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '계정상품이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.productDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.productInit();
              });
          })
        }else{
          // cansel
        }
      })
    },
    drUserAuthDeleteClear() {
      this.productDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    productAuthInfoGo(row) {
      var self = this;
      location.href = '#/product/userauthpermission/info';
      self.$session.set('auth_param_code', row.p_code);
    },
    dateMonthSelect (item) {
      var self = this;
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      // { item_name: '전체', item_code:'dayall', state: true },
      // { item_name: '오늘', item_code:'1|days',state: false },
      // { item_name: '1주일', item_code:'7|days',state: false },
      // { item_name: '1개월', item_code:'1|months',state: false },
      // { item_name: '6개월', item_code:'6|months',state: false },
      // { item_name: '1년', item_code:'1|years',state: false },
      self.queryParams.day_code = item.item_code;
      var addDateCnt = 0;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      setTimeout(function(){
        $('input[name="daterange"]').data('daterangepicker').setStartDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
  		  $('input[name="daterange"]').data('daterangepicker').setEndDate(moment().format('YYYY-MM-DD'));
        self.queryParams.start_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
        self.queryParams.end_date = moment().format('YYYY-MM-DD');
      }, 0);
    },
  }
}

</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/product/UserAuthPermissionList.vue